/* eslint-disable @typescript-eslint/ban-types */
import * as React from "react";
import {
  FilledInput,
  FilledInputProps,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
} from "@material-ui/core";
import { FieldAttributes, useField, useFormikContext } from "formik";
import { useEffect, useState } from "react";
import { CustomSearchSvg } from "../../assets/icons/custom-svg-components/CompanySvgCollection";

interface CustomSearchFieldProps {
  label: string;
  // eslint-disable-next-line no-unused-vars
  customChangeHandler?: (values: string) => void;
  initialValue?: string;
  hideEndAdornment?: boolean;
}

const CustomSearchField: React.FC<
  FieldAttributes<{}> & FilledInputProps & CustomSearchFieldProps
> = ({ label, customChangeHandler, initialValue, ...props }) => {
  const [field] = useField<{}>(props);
  const { setFieldValue } = useFormikContext();
  const [searchTerm, setSearchTerm] = useState(initialValue ? initialValue : "");

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchTerm !== field.value) {
        if (customChangeHandler) customChangeHandler(searchTerm);
        setFieldValue(field.name, searchTerm);
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [customChangeHandler, field.name, field.value, searchTerm, setFieldValue]);

  return (
    <FormControl fullWidth variant="filled">
      <InputLabel htmlFor="search">{label}</InputLabel>
      <FilledInput
        {...props}
        value={searchTerm}
        onChange={(e) => {
          setSearchTerm(e.target.value);
        }}
        endAdornment={
          props.hideEndAdornment ? null : (
            <InputAdornment position="end">
              <IconButton
                aria-label="search for keyword"
                onClick={() => {
                  setFieldValue(field.name, searchTerm);
                }}
                edge="end"
              >
                <CustomSearchSvg />
              </IconButton>
            </InputAdornment>
          )
        }
      />
    </FormControl>
  );
};

export default CustomSearchField;
